<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'LevelLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '申报批次'
            },
            {
              key: '2',
              title: '申报人员'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/skill/ApplyList':
                return '1'
              case '/skill/ApplyMemberList':
                return '2'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/skill/ApplyList')
                break
              case '2':
                this.$router.push('/skill/ApplyMemberList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
